import React from 'react';
import StyledCard from './StyledCard';

type Props = {
  hasShadow?: Boolean,
  children?: Element,
  type?: String,
  hasRadius?: Boolean,
  hasBorder?: Boolean,
  borderColor?: String,
  sliderShadow?: Boolean,
  width?: String,
  height?: String,
  radius?: String,
  hasAnimation?: Boolean,
};

Card.defaultProps = {
  hasShadow: false,
  hasRadius: true,
  hasBorder: false,
  type: 'transparent',
  sliderShadow: false,
  borderColor: 'lighterGray',
  radius: '16px',
  hasAnimation: true,
};

export default function Card({
  children,
  hasShadow,
  hasRadius,
  hasBorder,
  ...restProps
}: Props) {
  return (
    <StyledCard
      hasShadow={hasShadow}
      hasRadius={hasRadius}
      hasBorder={hasBorder}
      {...restProps}
    >
      {children}
    </StyledCard>
  );
}
